export default {"src":"/_next/static/media/logo-white.9aefab22.svg","height":177,"width":902,"blurWidth":0,"blurHeight":0};